import React from 'react';
import {Link/*, useRouteMatch, matchPath*/} from 'react-router-dom';
import {Button, Modal} from 'react-bootstrap';

import {routes} from '../config/globales';


class Header extends React.Component {
    render() {
        //let match = useRouteMatch();
        return (
            <header>
                <nav className="navbar navbar-primary bg-primary navbar-expand-lg navbar-fixed-top" role="navigation">
                    <a className="navbar-brand py-0" href="#">
				        {/*<img src="assets/images/logo.jpeg" alt="GL Pay - Paiement et transfert d'argent simplifié" />*/}
                        <h1><span>Afric</span>Pay</h1>
                    </a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#menu" aria-controls="menu" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="fa fa-bars"></span>{/*navbar-toggler-icon*/}
                    </button>
                    <div className="navbar-collapse collapse menu" id="menu">
                        <ul className="navbar-nav ml-auto" role="tablist">
                            {this.props.auth.utilisateur && 
                            (
                                routes.map((route, index) => {
                                    if (this.props.auth.utilisateur.type>=route.access) {
                                        if (route.inMenu) {
                                            return (
                                                <li className="nav-item" role="presentation" key={'menu-'+route.name+'-'+index}>
                                                    <Link className="nav-link text-dark" onClick={(e) => {document.querySelector("button.navbar-toggler").click()}} to={route.path}>{ route.label }</Link>
                                                </li>
                                            )
                                        }
                                        return (
                                            <li className="nav-item d-none" role="presentation" key={'menu-'+route.name+'-'+index}>
                                                <Link className="nav-link text-dark" data-toggle="collapse" data-target=".navbar-collapse.collapse" to={route.path}>{ route.label }</Link>
                                            </li>
                                        );
                                    }
                                    return "";
                                })
                            )}
                            {this.props.withLogout && (
                                <li className="nav-item" role="presentation">
                                    <span className="nav-link text-danger" data-toggle="collapse" data-target=".navbar-collapse.collapse" style={{cursor: "pointer"}} onClick={this.props.auth.deconnexion}>Déconnexion</span>
                                </li>
                            )}
                        </ul>
                    </div>
                </nav>
            </header>
        );
    }
}

class Footer extends React.Component {
    render() {
        return (
            <footer>
                <div className="footer bg-primary">
                    <div className="container py-3">
                        <div className="row">
                            <div className="col-sm-12 text-center">
                                <div className="copyright">
                                    &copy; 2020, AFRICPAY SARL. Tous droits reservés.
                                    <div className="credits">
                                        Développé et hébergé par l'entreprise <a href="https://legrandsoft.com/" target="_black" style={{fontSize: "14px"}}>Groupe legrandsoft</a>.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="pull-right text-right">
                        <a href="#home" className="scrollup"><i className="fa fa-angle-up fa-3x"></i></a>
                    </div>
                </div>
            </footer>
        );
    }
}
class Breadcrumb extends React.Component {
    render() {
        return (
            <div className="container">
                <div className="breadcrumb">
                    <li><Link to={routes[0].path}>{ routes[0].label }</Link></li>
                    <li className="text-secondary mx-2" style={{fontSize:"24px"}}>&gt;</li>
                    <li className="text-dark d-flex">{ this.props.text }</li>
                </div>
            </div>
        );
    }
}

class Loading extends React.Component {
    render() {
        if (this.props.show) {
            return (
                <div className="loading wow fadeInUp">
                    <img src="/assets/images/glpay-loading.gif" alt="GL Pay - Paiement et Transfert d'argent en un clic" />
                </div>
            );
        }
        return <div className="d-none"></div>;
    }
}

export {Header, Footer, Breadcrumb, Loading};